<template>
    <div>
        <CList :p-config-list="ConfigList">
            <template slot="bodyForm">
                <div class="container-flex justify-content-center">
                    <div v-if="VerificaApartadosVisible('CLAVEPENDIENTES')" class="container-box m-2">
                        <router-link :to="{name:'reportecortedia'}" class="color_text">
                            <div class="flexbox-01 text-center">
                                <i class="fas fa-sack-dollar"></i>
                            </div>
                            <p class="text-center text-box">Corte del Dia</p>
                        </router-link>
                    </div>

                    <div v-if="VerificaApartadosVisible('CLAVEAUTORIZADOS')" class="container-box m-2">
                        <router-link :to="{name:'reporteventasemanales'}" class="color_text">
                            <div class="flexbox-01 text-center">
                                <i class="fas fa-chart-line"></i>
                            </div>
                            <p class="text-center text-box">Ventas Semanales</p>
                        </router-link>
                    </div>

                   <div v-if="VerificaApartadosVisible('CLAVEPORENTREGAR')" class="container-box m-2">
                        <router-link :to="{name:'reportproductividadsemanales'}" class="color_text">
                            <div class="flexbox-01 text-center">
                                <i class="fas fa-calendar-week"></i>
                            </div>
                            <p class="text-center text-box">Cobranza Semanal</p>
                        </router-link>
                    </div>

                    <!-- <div v-if="VerificaApartadosVisible('CLAVERECHAZADOS')" class="container-box m-2">
                        <router-link :to="{name:'rechazados'}" class="color_text">
                            <div class="flexbox-01 text-center">
                                <i class="fas fa-trophy-alt"></i>
                            </div>
                            <p class="text-center text-box">Metas Semanales</p>
                        </router-link>
                    </div>-->
                </div>
            </template>
        </CList>
    </div>
</template>

<script>

const EmitEjecuta = 'seccionMenus';

export default {
    name:       "FormMenusReportes",
    props:      [''],
    components: { },
    data() {
        return {
            emmit:           EmitEjecuta,
            ConfigList: {
                ShowTitleFirst:    false,
                Title:             "Menús Reportes",
                IsModal:           false,
                BtnNewShow:        false,
                BtnReturnShow:     false,
                TypeBody:          "Form",
                ShowFiltros:       false,
                ShowFiltrosInline: false,
                ShowTitleInline:   false,
                ShowPaginador:     false,
                EmitSeccion:       EmitEjecuta
            },
            ListApartados: [],
			VerMenu: 0,
        }
    },
    methods:{
        VerificarPermisos()
		{
			this.$http.get(
				'panelmenuGetMenus',{}
			).then((res) => {
				this.ListApartados = res.data.Apartados;
				this.VerMenu = res.data.VerMenu;
			});
		},
        VerificaApartadosVisible(Clave)
		{
			let Val = this.ListApartados.find( item => item.Clave == Clave);
			if(this.VerMenu>0){
				return true;
			}
			if (!Val) return false;

            return true;
		}
    },
    created() {
		this.VerificarPermisos();
	},
}
</script>
